<template>
  <a class="edit-user" @click.stop="editUser()">
    {{ model.get('username') }}
  </a>
</template>

<script>
export default {
  props: {
    model: {
      require: true,
      type: Object
    }
  },

  methods: {
    editUser: function () {
      this.$router.push({
        name: 'user-edit',
        params: { id: this.model.get('user') }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-user {
  &:hover {
    color: $peter-liver;
  }
}
</style>
